import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Modal,
  ModalBody,
} from "reactstrap";
import history from "../../history";
import CartTitle from "../../components/CartTitle";
import Loader from "../Loader";
import MaterialTable from "material-table";
import { helperFunctionForStatus } from "../../utils/helperFunction";

import "../../assets/scss/components/MeterialTable/index.scss";

import get from "lodash/get";
import RideDetail from "../../components/RideDetail";
import { fetchQueryParams } from "../../utils/comman";

const _ = { get };

export default class ridesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: "PENDING",
      toggleModal: false,
      selectedId: "",
    };
  }

  componentDidMount() {
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    if (
      Object.keys(params).length > 0 &&
      params.status !== "" &&
      params.status != "undefined"
    ) {
      let newState = { ...this.state };
      newState.status = params.status;
      this.setState({ ...newState });
      console.log("par", params);
      if (this.props.page !== "moderation") {
        this.props.handleFetchAllRide();
      } else {
        this.props.handleFetchRidesForModeration(params.status);
      }
    } else {
      if (this.props.page !== "moderation") {
        this.props.handleFetchAllRide();
      } else {
        this.props.handleFetchRidesForModeration(this.state.status);
      }
    }
  }

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRowData = (data) => {
    let newState = { ...this.state };
    newState.selectedId = data._id;
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleChangeStatus = (e) => {
    {
      this.props.page === "moderation"
        ? history.replace("/rides/moderation")
        : history.replace("/rides/list");
    }
    let state = this.state;
    state.status = e.target.value;
    this.setState({ ...state });
    this.props.handleFetchRidesForModeration(this.state.status);
  };

  render() {
    let { elements } = this.props;

    console.log("props", this.props);
    console.log("id", this.state.selectedId);
    return (
      <div className="userListing hideSearch">
        {this.props.page !== "moderation" ? (
          this.props.allRidesStatus !== false ? (
            <Loader />
          ) : null
        ) : this.props.ridesForModerationStatus !== false ? (
          <Loader />
        ) : null}

        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "rideListTableElement.headingElement",
                "Rides"
              )}
              Name={"Search"}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
              iconClass={"hideexcel"}
            />
          </Col>
          {this.props.page === "moderation" ? (
            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col lg={5}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "rideListTableElement.statusLabelElement",
                          "Status"
                        )}
                      </Label>
                      <Input
                        type="select"
                        name="City"
                        value={this.state.status}
                        className="w-100 customeSelectBtn my-2"
                        onChange={this.handleChangeStatus}
                      >
                        <option value={"PENDING"}>
                          {_.get(
                            elements,
                            "rideListTableElement.pendingElement",
                            "Pending"
                          )}
                        </option>
                        <option value={"APPROVED"}>
                          {_.get(
                            elements,
                            "rideListTableElement.approvedElement",
                            "Approved"
                          )}
                        </option>
                        <option value={"REJECTED"}>
                          {_.get(
                            elements,
                            "rideListTableElement.rejectedElement",
                            "Rejected"
                          )}
                        </option>
                      </Input>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          ) : null}
        </Row>
        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.rideNameElement",
                      "Ride Name"
                    ),
                    field: "rideName",
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.branchNameElement",
                      "Branch Name"
                    ),

                    field: "branchName",
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.rideStatusElement",
                      "Ride Status"
                    ),
                    field: "rideStatus",
                    render: (rowData) =>
                      helperFunctionForStatus(rowData.rideStatus, elements),
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.rideTypeElement",
                      "Ride Type"
                    ),
                    field: "rideInfo.rideLevel",
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.moderationStatusElement",
                      "Moderation Status"
                    ),
                    field: "moderationStatus",
                    render: (rowData) =>
                      helperFunctionForStatus(
                        rowData.moderationStatus,
                        elements
                      ),
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.countryElement",
                      "Country"
                    ),
                    field: "rideInfo.country",
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.statsElement",
                      "State"
                    ),
                    field: "rideInfo.state",
                  },
                  {
                    title: _.get(
                      elements,
                      "rideListTableElement.cityElement",
                      "City"
                    ),
                    field: "rideInfo.city",
                  },
                ]}
                data={
                  this.props.page !== "moderation"
                    ? this.props.allRides
                    : this.props.ridesForModeration
                }
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: 10,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: _.get(
                      elements,
                      "rideListTableElement.detailPageElement",
                      "Detail Page"
                    ),
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "rideListTableElement.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "rideListTableElement.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </div>
          </Col>
        </Row>
        <Modal
          isOpen={this.state.toggleModal}
          toggle={this.handleToggleModel}
          backdrop={true}
          centered={true}
          className="modal_main"
          size="xl"
        >
          <ModalBody className="modalBody">
            <RideDetail
              page={this.props.page}
              allRides={this.props.allRides}
              allRidesStatus={this.props.allRidesStatus}
              handleFetchAllRide={this.props.handleFetchAllRide}
              handleFetchSingleRide={this.props.handleFetchSingleRide}
              elements={this.props.elements}
              singleRide={this.props.singleRide}
              singleRideStatus={this.props.singleRideStatus}
              query={this.props.query}
              handleUsersForJoinRide={this.props.handleUsersForJoinRide}
              handleUsersModerationForJoinRide={
                this.props.handleUsersModerationForJoinRide
              }
              handleJoinUser={this.props.handleJoinUser}
              handleFetchAllUser={this.props.handleFetchAllUser}
              handleClearPreviousReducer={this.props.handleClearPreviousReducer}
              handleFetchImagesForModeration={
                this.props.handleFetchImagesForModeration
              }
              handleRideGallery={this.props.handleRideGallery}
              allUserStatus={this.props.allUserStatus}
              allUser={this.props.allUser}
              usersToJoinRideStatus={this.props.usersToJoinRideStatus}
              usersToJoinRide={this.props.usersToJoinRide}
              moderationStatusForUser={this.props.moderationStatusForUser}
              moderateRideGalleyStatus={this.props.moderateRideGalleyStatus}
              selectedId={this.state.selectedId}
              status={this.state.status}
              handleToggleModel={this.handleToggleModel}
              handleRideModeration={this.props.handleRideModeration}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
